// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/SwipeableCard/SwipeableCard.css */

.swipeable-card {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-fach-1);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  position: relative;
  cursor: grab;
  will-change: transform, opacity;
  touch-action: pan-y;
  user-select: none;
  -webkit-user-select: none;
  min-height: 140px;
}

.swipeable-card:active {
  cursor: grabbing;
}

.swipeable-card--revealing {
  cursor: default;
}

.swipeable-card--exiting {
  pointer-events: none;
}

/* ---- Card flip wrapper ---- */
.swipeable-card__flip-inner {
  position: relative;
  width: 100%;
  min-height: 140px;
  transition: transform 0.5s ease;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
}

.swipeable-card__flip-inner--flipped {
  transform: rotateY(180deg);
}

.swipeable-card__flip-front,
.swipeable-card__flip-back {
  width: 100%;
  min-height: 140px;
  backface-visibility: hidden;
}

.swipeable-card__flip-front {
  position: relative;
  z-index: 2;
}

.swipeable-card__flip-inner--flipped .swipeable-card__flip-front {
  visibility: hidden;
}

.swipeable-card__flip-back {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg) var(--space-md);
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  z-index: 1;
}

.swipeable-card__flip-inner--flipped .swipeable-card__flip-back {
  visibility: visible;
}

.swipeable-card__flip-back-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--space-xs);
}

.swipeable-card__flip-back-word {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-wood-medium);
  text-align: center;
  line-height: var(--line-height-tight);
}

.swipeable-card__flip-back-meta {
  margin-top: var(--space-sm);
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  display: flex;
  gap: var(--space-xs);
  align-items: center;
}

.swipeable-card__flip-back-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px var(--space-xs);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: white;
}

/* ---- Swipe direction overlays ---- */
.swipeable-card__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 10;
  border-radius: var(--radius-lg);
  transition: opacity 0.05s linear;
}

.swipeable-card__overlay--right {
  background-color: var(--color-success);
}

.swipeable-card__overlay--left {
  background-color: var(--color-error);
}

.swipeable-card__overlay-icon {
  font-size: 2.5rem;
  font-weight: var(--font-weight-extrabold);
  color: white;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* ---- Score indicators ---- */
.swipeable-card__score {
  position: absolute;
  top: var(--space-xs);
  right: var(--space-sm);
  display: flex;
  gap: var(--space-xs);
  z-index: 5;
}

.swipeable-card__score-item {
  font-size: 0.6rem;
  font-weight: var(--font-weight-bold);
  padding: 1px var(--space-xs);
  border-radius: var(--radius-sm);
}

.swipeable-card__score-item--correct {
  color: #076960;
}

.swipeable-card__score-item--wrong {
  color: #9333ea;
}

.swipeable-card__score-item--total {
  color: #4338ca;
}

/* ---- Card body ---- */
.swipeable-card__body {
  padding: var(--space-lg) var(--space-md);
  text-align: center;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  position: relative;
  z-index: 1;
}

.swipeable-card__word {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  font-style: italic;
  transition: color var(--transition-normal);
}

.swipeable-card__question {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  font-style: italic;
  line-height: var(--line-height-tight);
}

.swipeable-card__divider {
  width: 50px;
  height: 2px;
  background-color: var(--color-border);
  border-radius: 1px;
  margin: var(--space-xs) 0;
}

.swipeable-card__answer {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  line-height: var(--line-height-tight);
  animation: reveal-pop 0.3s ease-out;
}

@keyframes reveal-pop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* ---- Reveal timer ---- */
.swipeable-card__reveal-timer {
  width: 100%;
  max-width: 150px;
  margin-top: var(--space-xs);
  position: relative;
  height: 16px;
  background-color: var(--color-progress-bg);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.swipeable-card__reveal-timer-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--color-error), var(--color-accent));
  border-radius: var(--radius-full);
  transition: width 1s linear;
}

.swipeable-card__reveal-timer-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

/* ---- Meta info ---- */
.swipeable-card__meta {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  display: flex;
  gap: var(--space-xs);
  align-items: center;
}

.swipeable-card__meta-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px var(--space-xs);
  border-radius: var(--radius-full);
  font-size: 0.6rem;
  font-weight: var(--font-weight-semibold);
  color: white;
}

/* ---- Action buttons ---- */
.swipeable-card__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-xs) var(--space-sm);
  border-top: 1px solid var(--color-border);
  position: relative;
  z-index: 5;
}

.swipeable-card__action-btn {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  opacity: 0.5;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px var(--space-xs);
  border-radius: var(--radius-sm);
  transition: opacity var(--transition-fast), background-color var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.swipeable-card__action-btn:hover:not(:disabled) {
  opacity: 0.8;
}

.swipeable-card__action-btn:active:not(:disabled) {
  opacity: 1;
}

.swipeable-card__action-btn:disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.swipeable-card__action-btn--left {
  color: var(--color-error);
}

.swipeable-card__action-btn--translate {
  color: var(--color-wood-medium);
}

.swipeable-card__action-btn--translate--active {
  opacity: 0.9;
  background-color: rgba(139, 94, 60, 0.08);
}

.swipeable-card__action-btn--right {
  color: var(--color-success);
}

/* ---- Pronunciation Section ---- */
.swipeable-card__pronunciation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: var(--space-xs) var(--space-sm);
  border-top: 1px solid var(--color-border);
  position: relative;
  z-index: 5;
}

.swipeable-card__pronunciation-row {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  width: 100%;
  justify-content: center;
}

.swipeable-card__play-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 3px var(--space-sm);
  border-radius: var(--radius-full);
  border: 1px solid var(--color-wood-medium);
  background-color: transparent;
  color: var(--color-wood-medium);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  min-height: 26px;
}

.swipeable-card__play-btn:hover:not(:disabled) {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
}

.swipeable-card__play-btn:active:not(:disabled) {
  background-color: var(--color-wood-dark);
  color: var(--color-text-on-wood);
  transform: scale(0.96);
}

.swipeable-card__play-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.swipeable-card__play-btn--loading {
  border-color: var(--color-text-light);
  color: var(--color-text-light);
}

.swipeable-card__play-btn--playing {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  animation: play-pulse 1s ease-in-out infinite;
}

@keyframes play-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.swipeable-card__play-btn-icon {
  font-size: var(--font-size-xs);
  line-height: 1;
}

.swipeable-card__play-btn-icon svg {
  width: 12px;
  height: 12px;
  fill: currentColor;
}

.swipeable-card__example-sentence {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  font-style: italic;
  text-align: center;
  line-height: var(--line-height-normal);
  max-width: 100%;
  word-break: break-word;
  padding: 0 var(--space-xs);
  animation: reveal-pop 0.3s ease-out;
}

.swipeable-card__pronunciation-error {
  font-size: var(--font-size-xs);
  color: var(--color-error);
  text-align: center;
}

/* ---- Completion / Empty state ---- */
.swipeable-card-completion {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-border);
  box-shadow: var(--shadow-md);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  min-height: 140px;
  padding: var(--space-lg);
  transition: border-color var(--transition-normal);
}

.swipeable-card-completion__icon {
  font-size: 2.5rem;
}

.swipeable-card-completion__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.swipeable-card-completion__text {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/components/SwipeableCard/SwipeableCard.css"],"names":[],"mappings":"AAAA,wGAAwG;;AAExG;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EAEjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;EAC9B,wCAAwC;EACxC,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2EAA2E;EAC3E,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,iBAAiB;EACjB,wCAAwC;EACxC,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,mFAAmF;EACnF,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,iCAAiC;EACjC,0CAA0C;EAC1C,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,qBAAqB;AACvB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/SwipeableCard/SwipeableCard.css */\n\n.swipeable-card {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-fach-1);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  position: relative;\n  cursor: grab;\n  will-change: transform, opacity;\n  touch-action: pan-y;\n  user-select: none;\n  -webkit-user-select: none;\n  min-height: 140px;\n}\n\n.swipeable-card:active {\n  cursor: grabbing;\n}\n\n.swipeable-card--revealing {\n  cursor: default;\n}\n\n.swipeable-card--exiting {\n  pointer-events: none;\n}\n\n/* ---- Card flip wrapper ---- */\n.swipeable-card__flip-inner {\n  position: relative;\n  width: 100%;\n  min-height: 140px;\n  transition: transform 0.5s ease;\n  transform-style: preserve-3d;\n  -webkit-transform-style: preserve-3d;\n}\n\n.swipeable-card__flip-inner--flipped {\n  transform: rotateY(180deg);\n}\n\n.swipeable-card__flip-front,\n.swipeable-card__flip-back {\n  width: 100%;\n  min-height: 140px;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.swipeable-card__flip-front {\n  position: relative;\n  z-index: 2;\n}\n\n.swipeable-card__flip-inner--flipped .swipeable-card__flip-front {\n  visibility: hidden;\n}\n\n.swipeable-card__flip-back {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transform: rotateY(180deg);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-lg) var(--space-md);\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  z-index: 1;\n}\n\n.swipeable-card__flip-inner--flipped .swipeable-card__flip-back {\n  visibility: visible;\n}\n\n.swipeable-card__flip-back-label {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: var(--space-xs);\n}\n\n.swipeable-card__flip-back-word {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-wood-medium);\n  text-align: center;\n  line-height: var(--line-height-tight);\n}\n\n.swipeable-card__flip-back-meta {\n  margin-top: var(--space-sm);\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  display: flex;\n  gap: var(--space-xs);\n  align-items: center;\n}\n\n.swipeable-card__flip-back-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px var(--space-xs);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  color: white;\n}\n\n/* ---- Swipe direction overlays ---- */\n.swipeable-card__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 10;\n  border-radius: var(--radius-lg);\n  transition: opacity 0.05s linear;\n}\n\n.swipeable-card__overlay--right {\n  background-color: var(--color-success);\n}\n\n.swipeable-card__overlay--left {\n  background-color: var(--color-error);\n}\n\n.swipeable-card__overlay-icon {\n  font-size: 2.5rem;\n  font-weight: var(--font-weight-extrabold);\n  color: white;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* ---- Score indicators ---- */\n.swipeable-card__score {\n  position: absolute;\n  top: var(--space-xs);\n  right: var(--space-sm);\n  display: flex;\n  gap: var(--space-xs);\n  z-index: 5;\n}\n\n.swipeable-card__score-item {\n  font-size: 0.6rem;\n  font-weight: var(--font-weight-bold);\n  padding: 1px var(--space-xs);\n  border-radius: var(--radius-sm);\n}\n\n.swipeable-card__score-item--correct {\n  color: #076960;\n}\n\n.swipeable-card__score-item--wrong {\n  color: #9333ea;\n}\n\n.swipeable-card__score-item--total {\n  color: #4338ca;\n}\n\n/* ---- Card body ---- */\n.swipeable-card__body {\n  padding: var(--space-lg) var(--space-md);\n  text-align: center;\n  min-height: 110px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n  position: relative;\n  z-index: 1;\n}\n\n.swipeable-card__word {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  font-style: italic;\n  transition: color var(--transition-normal);\n}\n\n.swipeable-card__question {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  font-style: italic;\n  line-height: var(--line-height-tight);\n}\n\n.swipeable-card__divider {\n  width: 50px;\n  height: 2px;\n  background-color: var(--color-border);\n  border-radius: 1px;\n  margin: var(--space-xs) 0;\n}\n\n.swipeable-card__answer {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-extrabold);\n  line-height: var(--line-height-tight);\n  animation: reveal-pop 0.3s ease-out;\n}\n\n@keyframes reveal-pop {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* ---- Reveal timer ---- */\n.swipeable-card__reveal-timer {\n  width: 100%;\n  max-width: 150px;\n  margin-top: var(--space-xs);\n  position: relative;\n  height: 16px;\n  background-color: var(--color-progress-bg);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.swipeable-card__reveal-timer-bar {\n  height: 100%;\n  background: linear-gradient(90deg, var(--color-error), var(--color-accent));\n  border-radius: var(--radius-full);\n  transition: width 1s linear;\n}\n\n.swipeable-card__reveal-timer-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n/* ---- Meta info ---- */\n.swipeable-card__meta {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  display: flex;\n  gap: var(--space-xs);\n  align-items: center;\n}\n\n.swipeable-card__meta-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px var(--space-xs);\n  border-radius: var(--radius-full);\n  font-size: 0.6rem;\n  font-weight: var(--font-weight-semibold);\n  color: white;\n}\n\n/* ---- Action buttons ---- */\n.swipeable-card__actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-xs) var(--space-sm);\n  border-top: 1px solid var(--color-border);\n  position: relative;\n  z-index: 5;\n}\n\n.swipeable-card__action-btn {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  opacity: 0.5;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px var(--space-xs);\n  border-radius: var(--radius-sm);\n  transition: opacity var(--transition-fast), background-color var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.swipeable-card__action-btn:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.swipeable-card__action-btn:active:not(:disabled) {\n  opacity: 1;\n}\n\n.swipeable-card__action-btn:disabled {\n  opacity: 0.2;\n  cursor: not-allowed;\n}\n\n.swipeable-card__action-btn--left {\n  color: var(--color-error);\n}\n\n.swipeable-card__action-btn--translate {\n  color: var(--color-wood-medium);\n}\n\n.swipeable-card__action-btn--translate--active {\n  opacity: 0.9;\n  background-color: rgba(139, 94, 60, 0.08);\n}\n\n.swipeable-card__action-btn--right {\n  color: var(--color-success);\n}\n\n/* ---- Pronunciation Section ---- */\n.swipeable-card__pronunciation {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: var(--space-xs) var(--space-sm);\n  border-top: 1px solid var(--color-border);\n  position: relative;\n  z-index: 5;\n}\n\n.swipeable-card__pronunciation-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n  width: 100%;\n  justify-content: center;\n}\n\n.swipeable-card__play-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  padding: 3px var(--space-sm);\n  border-radius: var(--radius-full);\n  border: 1px solid var(--color-wood-medium);\n  background-color: transparent;\n  color: var(--color-wood-medium);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  min-height: 26px;\n}\n\n.swipeable-card__play-btn:hover:not(:disabled) {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n}\n\n.swipeable-card__play-btn:active:not(:disabled) {\n  background-color: var(--color-wood-dark);\n  color: var(--color-text-on-wood);\n  transform: scale(0.96);\n}\n\n.swipeable-card__play-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.swipeable-card__play-btn--loading {\n  border-color: var(--color-text-light);\n  color: var(--color-text-light);\n}\n\n.swipeable-card__play-btn--playing {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  animation: play-pulse 1s ease-in-out infinite;\n}\n\n@keyframes play-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.swipeable-card__play-btn-icon {\n  font-size: var(--font-size-xs);\n  line-height: 1;\n}\n\n.swipeable-card__play-btn-icon svg {\n  width: 12px;\n  height: 12px;\n  fill: currentColor;\n}\n\n.swipeable-card__example-sentence {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n  font-style: italic;\n  text-align: center;\n  line-height: var(--line-height-normal);\n  max-width: 100%;\n  word-break: break-word;\n  padding: 0 var(--space-xs);\n  animation: reveal-pop 0.3s ease-out;\n}\n\n.swipeable-card__pronunciation-error {\n  font-size: var(--font-size-xs);\n  color: var(--color-error);\n  text-align: center;\n}\n\n/* ---- Completion / Empty state ---- */\n.swipeable-card-completion {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-border);\n  box-shadow: var(--shadow-md);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  min-height: 140px;\n  padding: var(--space-lg);\n  transition: border-color var(--transition-normal);\n}\n\n.swipeable-card-completion__icon {\n  font-size: 2.5rem;\n}\n\n.swipeable-card-completion__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.swipeable-card-completion__text {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n  white-space: pre-line;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
